import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompanies = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				stroke: "#748094",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.2,
				d: "M11.264 7.429h6.015V16h-6.015z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 2.406,
				height: 1,
				x: 13.068,
				y: 9.265,
				fill: "#748094",
				rx: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#748094",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.2,
				d: "M2.842 4h8.42v12h-8.42z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 3.368,
				height: 1,
				x: 5.369,
				y: 6.571,
				fill: "#748094",
				rx: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#748094",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.2,
				d: "M2 16h16"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h20v20H0z"
		})
	}) })]
});
export default SvgCompanies;
